import React from "react";
import { ArticleFeedItem } from "components/feedsSection/articleFeedItem";
import type { ArticleShort } from "lib/types/article";

export type InsightsArticleListProps = {
  articles: ArticleShort[];
  className?: string;
};

export const InsightsArticleList: React.FC<InsightsArticleListProps> = ({
  articles,
  className,
}) => {
  return (
    <div className={className}>
      <div className="flex flex-col">
        {articles.map((article, index) => (
          <ArticleFeedItem
            key={article.id || article.url}
            article={article}
            position={index}
          />
        ))}
      </div>
    </div>
  );
};
